import { Fragment } from "react";
import Menu from "../../modules/public/menu/menu";
import Footer from "../../modules/public/footer/footer";
import WebServiceForm from "./WebServiceForm";

const WebServicePage = () => {
  return (
    <Fragment>
      <Menu />
      <WebServiceForm />
      <Footer />
    </Fragment>
  );
};

export default WebServicePage;
